module.exports = {
    MAX_STORES: 10,
    STORE_TYPES: {
        PREPEND_SEPHORA: ['SIKLS']
    },
    EXPIRY_MINUTES: 30
};
